<div [ngClass]="['alert-container', 'alert-' + variant, brightStyle ? 'brightStyle' : '']">
    <nb-alert>
        <div class="alert-text">
            <nb-icon icon="{{ icon }}"></nb-icon>
            {{ message }}
            <a *ngIf="linkText" (click)="onClick($event)" class="link" aria-label="Back">
                {{ linkText }}
            </a>
            <button *ngIf="buttonText" (click)="onButtonClicked.emit(true)" nbButton status="basic" size="small">
                <nb-icon *ngIf="buttonIcon" [icon]="buttonIcon.icon" [pack]="buttonIcon.pack || 'eva'"></nb-icon>
                {{ buttonText }}
            </button>

            <div *ngIf="showCloseBtn" (click)="onCloseClicked.emit()">
                <nb-icon icon="close" status="basic" class="pointer"></nb-icon>
            </div>
        </div>
    </nb-alert>
</div>
